export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9704.c31ef661.jpg";